import {
    NAME_SPACE,
    useLoadTranslations,
} from '@/frontend/src/hooks/useLoadTranslations';
import AppContent from '@/frontend/src/components/AppContent';

const App = () => {
    useLoadTranslations(NAME_SPACE);

    return <AppContent />;
};

export default App;
